import { Pax } from '../shared/interfaces/button-menu.interface';

export const listClass = [
  { value: 'all', label: 'Todas' },
  { value: 'Y', label: 'Económica' },
  { value: 'W', label: 'Superior' },
  { value: 'C', label: 'Business' },
  { value: 'F', label: 'Primera' },
];

export const listMoney = [
  { value: 'ARS', label: 'ARS' },
  { value: 'USD', label: 'USD' },
];

type PaxKey = keyof Pax;

export const defaultPax: {
  key: PaxKey;
  label: string;
  description: string;
  min: number;
}[] = [
  { key: 'adults', label: 'Adulto', description: '+ 12 años', min: 1 },
  { key: 'children', label: 'Niños', description: '2-11 años', min: 0 },
  { key: 'infants', label: 'Bebés', description: '< 2 años', min: 0 },
];
